import * as React from 'react';
import { IList, IPage } from '@fluentui/react';
import { SectionScrollPosition } from 'grouped-combobox-core';
import { FirstElementFocusWorker } from './FirstElementFocusWorker';
import { LastElementFocusWorker } from './LastElementFocusWorker';

export class ListListener {
    private firstElementWorker: FirstElementFocusWorker;
    private lastElementWorker: LastElementFocusWorker;

    public constructor(list: React.RefObject<IList>, root: React.RefObject<HTMLElement>) {
        this.firstElementWorker = new FirstElementFocusWorker(list, root);
        this.lastElementWorker = new LastElementFocusWorker(list, root);
    }

    public itemCount = 0;

    public onPageUpdates(pages: IPage[]): void {
        if (pages.length === 0) {
            return;
        }

        // find the first page that is not a spacer.
        const firstPage = pages.find((page) => !page.isSpacer);
        if (firstPage) {
            if (firstPage.startIndex === 0) {
                this.firstElementWorker.onElementCreated();
            } else {
                this.firstElementWorker.onElementRemoved();
            }
        }

        for (let i = pages.length; i > 0; --i) {
            // find the last page that is not a spacer.
            const lastPage = pages[i - 1];
            if (!lastPage.isSpacer) {
                if (lastPage.startIndex + lastPage.itemCount === this.itemCount) {
                    this.lastElementWorker.onElementCreated();
                } else {
                    this.lastElementWorker.onElementRemoved();
                }
                break;
            }
        }
    }

    public scrollToAndFocus(position: SectionScrollPosition): void {
        if (position === 'FirstElement') {
            this.firstElementWorker.scrollAndFocus(this.itemCount);
        } else if (position === 'LastElement') {
            this.lastElementWorker.scrollAndFocus(this.itemCount);
        }
    }

    public onCollapsed(): void {
        this.firstElementWorker.onCollapsed();
    }
}
